<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dOpoNI/images/cover.jpg?1684229399332" alt="This image is the cover for the book Women in Long Island's Past"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Women in Long Island's Past
      </h1>
      <p class="bookDescription body article font2">
        <p>Women have been part of Long Island's past for thousands of years but are nearly invisible in the records and history books. From pioneering doctors to dazzling aviatrixes, author Natalie A. Naylor brings these larger-than-life but little-known heroines out of the lost pages of island history. Anna Symmes Harrison, Julia Gardiner Tyler, Edith Kermit Roosevelt and Eleanor Roosevelt all served as first lady of the United States, and all had Long Island roots. Beloved children's author Frances Hodgson Burnett wrote The Secret Garden here, and hundreds of local suffragists fought for their right to vote in the early twentieth century. Discover these and other stories of the remarkable women of Long Island.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Natalie A. Naylor
      </h2>
      
      <p class="authorDescription body article">Natalie Naylor taught at Hofstra University for more than thirty years, and was founding director of the Long Island Studies Institute. She is trustee and president of the Nassau County Historical Society. She was also co-president of the Long Island Studies Council and editor of its newsletter.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d86d5ae